import cn from 'classnames'

export type SpinnerSize = 6 | 16

export type SpinnerProps = {
  size?: SpinnerSize
}

export function Spinner({ size = 16 }: SpinnerProps) {
  return (
    <div
      className={cn(
        'border-4 border-petrol border-t-transparent border-solid rounded-full animate-spin',
        {
          'w-6 h-6': size === 6,
          'w-16 h-16': size === 16,
        }
      )}
    />
  )
}
